import React, { Component } from "react";

import { Card, Button, Table, Modal, Select, Input, Tooltip, Tag } from "antd";

import { connect } from "react-redux";
import {
  req_page_eca_english_course_students_points_rank,
  req_downloadfile_ams_alumni,
  req_list_eca_activity_participate_points,
} from "../../api";
//import { formateDate } from '../../utils/dateUtil'
import { API_BASE, PAGE_SIZE, SORT_UP_DOWN } from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
import StudentPointsModal from "./student-points-modal";

class EnglishActivityPointsRank extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: "TotalPoints",
    orderBy: SORT_UP_DOWN,
    searchField: "None",
    searchValue: "",
    filterStatus: "",
    domnloadFile: "",

    nowAcademicYear: getNowAcademicYear(new Date()),
    nowAcademicSemester: getNowAcademicSemester(new Date()),

    points: [],
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // componentWillUnmount(){
  //     window.removeEventListener("resize", this.resize.bind(this))
  // }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
    } = this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    this.setState({ loading: true, items: [] });
    const result = await req_page_eca_english_course_students_points_rank(
      userCode,
      userLevel,
      nowAcademicYear,
      nowAcademicSemester,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });
    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_list_items = async (item) => {
    //console.log(this.props.student)
    const { AcademicYear, AcademicSemester, StudentId } = item;
    const { token } = this.props.user;

    const result = await req_list_eca_activity_participate_points(
      AcademicYear,
      AcademicSemester,
      StudentId,
      token
    );

    console.log(result);
    if (result) {
      const points = result;
      this.setState({ points });
      //console.log(this.state);
    } else {
      const points = [];
      this.setState({ points });
    }
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_ams_alumni(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "排名清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "課程名稱",
        dataIndex: "CourseTwName",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "授課老師",
        dataIndex: "TeacherName",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學號",
        dataIndex: "StudentId",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "姓名",
        dataIndex: "TwName",
        width: 40,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "點數",
        dataIndex: "",
        width: 40,
        responsive: ["md"],
        render: (item) => {
          const { TotalPoints, IsMutliCourse } = item;
          return (
            <>
              {TotalPoints}
              {IsMutliCourse === "N" ? (
                ""
              ) : (
                <span style={{ fontSize: "1.3em", color: "Red" }}>*</span>
              )}
            </>
          );
        },
      },
      {
        title: "操作項目",
        dataIndex: "",
        width: 40,
        render: (item) => {
          return (
            <>
              <Button
                type="dashed"
                onClick={() => this.handle_show_ui_modal("view", item)}
              >
                <i className="fas fa-file-powerpoint"></i>{" "}
                <span style={{ marginLeft: "4px" }}>紀錄</span>
              </Button>
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {}
  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.api_list_items(item);
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      default:
    }
  };
  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      isShowModal,
      nowAcademicYear,
      nowAcademicSemester,
      points,
    } = this.state;
    const title = (
      <span>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicYear}
          onChange={(event) =>
            this.setState({ nowAcademicYear: event.target.value })
          }
        />
        <Input
          placeholder="學期"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicSemester}
          onChange={(event) =>
            this.setState({ nowAcademicSemester: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">搜索條件</Select.Option>
          <Select.Option value="StudentId">學號</Select.Option>
          <Select.Option value="TwName">姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 150, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i> 查詢
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
      </span>
    );
    return (
      <Card>
        {title}
        <p></p>
        <Tag color="#2B3557 ">註：固定每日午夜12時結算點數</Tag>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          title="查詢點數歷程"
          visible={isShowModal}
          width={500}
          onOk={() => {
            this.setState({ isShowModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <StudentPointsModal points={points} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(EnglishActivityPointsRank);
